module.exports = __webpack_public_path__ + "static/media/22712264_1629551840453334_8573326660556492555_o.85b4adbd.jpg";